import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ModelNotification\GetMetadataFromModelController::__invoke
* @see app/Http/Controllers/ModelNotification/GetMetadataFromModelController.php
* @route '/api/model-notification/metadata-from-model'
*/
const GetMetadataFromModelController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetMetadataFromModelController.url(options),
    method: 'get',
})

GetMetadataFromModelController.definition = {
    methods: ["get","head"],
    url: '/api/model-notification/metadata-from-model',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ModelNotification\GetMetadataFromModelController::__invoke
* @see app/Http/Controllers/ModelNotification/GetMetadataFromModelController.php
* @route '/api/model-notification/metadata-from-model'
*/
GetMetadataFromModelController.url = (options?: RouteQueryOptions) => {
    return GetMetadataFromModelController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModelNotification\GetMetadataFromModelController::__invoke
* @see app/Http/Controllers/ModelNotification/GetMetadataFromModelController.php
* @route '/api/model-notification/metadata-from-model'
*/
GetMetadataFromModelController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetMetadataFromModelController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ModelNotification\GetMetadataFromModelController::__invoke
* @see app/Http/Controllers/ModelNotification/GetMetadataFromModelController.php
* @route '/api/model-notification/metadata-from-model'
*/
GetMetadataFromModelController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetMetadataFromModelController.url(options),
    method: 'head',
})

export default GetMetadataFromModelController